import { render, staticRenderFns } from "./k-icon.vue?vue&type=template&id=ba41d212"
import script from "./k-icon.vue?vue&type=script&lang=js"
export * from "./k-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports